export const publishedBlogs = [
  {
    slug: 'cadence-system-design',
    title: 'Cadence: A System Design Deep Dive',
    href: '/blogs/cadence-system-design',
    logoSrc: '/cadence-logo.svg',
    logoAlt: 'Cadence logo',
    accentClass: 'bg-purple-500/10 text-purple-700 dark:bg-purple-400/15 dark:text-purple-200',
    updatedLabel: '15 Apr, 2026',
    statusLabel: 'Published',
  },
  {
    slug: 'docker-guide',
    title: 'Docker: From Fundamentals to Practical Usage (Complete Guide)',
    href: '/blogs/docker-guide',
    logoSrc: 'https://cdn.simpleicons.org/docker/2496ED',
    logoAlt: 'Docker logo',
    accentClass: 'bg-[#2496ED]/10 text-[#2496ED] dark:bg-[#2496ED]/15 dark:text-[#7fc4ff]',
    updatedLabel: '30 Mar, 2026',
    statusLabel: 'Published',
  },
  {
    slug: 'cloudflare-tunnel-guide',
    title: 'Self-Hosting a Linux Server with Cloudflare Tunnel',
    href: '/blogs/cloudflare-tunnel-guide',
    logoSrc: 'https://cdn.simpleicons.org/cloudflare/F38020',
    logoAlt: 'Cloudflare logo',
    accentClass: 'bg-[#F38020]/10 text-[#F38020] dark:bg-[#F38020]/15 dark:text-[#ffb36a]',
    updatedLabel: '10 Feb, 2026',
    statusLabel: 'Published',
  },
];

export function getExploreBlogs(currentSlug) {
  return publishedBlogs.filter((blog) => blog.slug !== currentSlug);
}
